export enum ExportType {
  ExportBillings = 1,
  ExportFrozenData = 2,
  ExportReadings = 3,
  ExportQee = 4,
  ExportMeterAlarms = 5,
  ExportTickets = 6,
  ExportBillingMeters = 7,
  ExportSmcs = 8,
  ExportMeters = 11,
  ExportSMIStatistics = 15,
  ExportSMCStatistics = 16,
  ExportSMCAlarms = 17,
  ExportSMIAlarms = 18,
  ExportDrpViolations = 19,
  ExportDrcViolations = 20,
  ExportReadingsMonthly = 21,
  ExportDrpDrcAverage = 22,
  ExportDrpDrcViolationsMeasures = 23,
  ExportMetersByGroup = 32,
  ExportDashboardCharts = 33,
  ExportCustomReport = 34,
  ExportCustomReportLoad = 31,
  ExportWorstDrpDrcRanking = 35,
  ExportGroupQualityParameters = 43,
  ExportGroupDicFicMonthly = 44,
  ExportGroupLatestQualityParameters = 45,
}

export enum ComissionOption {
  Comissioned = 1,
  NotComissioned = 2,
  Unregistered = 3,
}

export enum ExportStatus {
  Processing = 1,
  Completed = 2,
  Failed = 3,
}

export interface IExportTaskDTO {
  taskId: string
  name: string
  exportType: ExportType
  date: Date
  status: ExportStatus
}

export class ExportTaskDTO implements IExportTaskDTO {
  public taskId: string = ''
  public name: string = ''
  public exportType: ExportType = ExportType.ExportBillings
  public date: Date = new Date()
  public status: ExportStatus = ExportStatus.Processing

  public static getExportTypeName(exportType: ExportType): string {
    switch (exportType) {
      case ExportType.ExportBillings:
        return 'Faturamento'
      case ExportType.ExportFrozenData:
        return 'Totalizadores de Energia'
      case ExportType.ExportReadings:
        return 'Leituras'
      case ExportType.ExportQee:
        return 'QEE'
      case ExportType.ExportMeterAlarms:
        return 'Alarmes de Medidores'
      case ExportType.ExportTickets:
        return 'Tickets'
      case ExportType.ExportMeters:
        return 'Medidores'
      case ExportType.ExportBillingMeters:
        return 'Medidores de Faturamento'
      case ExportType.ExportSmcs:
        return 'SMCs'
      case ExportType.ExportSMCStatistics:
        return 'Estatísticas de Alarmes de SMC'
      case ExportType.ExportSMIStatistics:
        return 'Estatísticas de Alarmes de SMI'
      case ExportType.ExportSMCAlarms:
        return 'Alarmes de SMC'
      case ExportType.ExportSMIAlarms:
        return 'Alarmes de SMI'
      case ExportType.ExportDrpViolations:
        return 'Violations DRP'
      case ExportType.ExportDrcViolations:
        return 'Violations DRC'
      case ExportType.ExportReadingsMonthly:
        return 'Leituras Mensais'
      case ExportType.ExportDrpDrcAverage:
        return 'Média DRP/DRC'
      case ExportType.ExportDrpDrcViolationsMeasures:
        return 'Medidas de Violations DRP/DRC'
      case ExportType.ExportMetersByGroup:
        return 'Medidores por Grupo'
      case ExportType.ExportDashboardCharts:
        return 'Variação Abrupta'
      case ExportType.ExportCustomReport:
        return 'Exportação de dados'
      case ExportType.ExportCustomReportLoad:
        return 'Relatório Customizado'
      case ExportType.ExportWorstDrpDrcRanking:
        return 'Instalações com Piores Indicadores DRP/DRC'
      case ExportType.ExportGroupQualityParameters:
        return 'Parâmetros de Qualidade por Grupo'
      case ExportType.ExportGroupDicFicMonthly:
        return 'Média de DIC/FIC mensal por Grupo'
      case ExportType.ExportGroupLatestQualityParameters:
        return 'Parâmetros de Qualidade mais recentes por Grupo'
      default:
        return 'Relatório Customizado'
    }
  }
}
